import React, { useState } from 'react';
import { View, Text, TextInput, FlatList } from 'react-native';
import Slider from 'tamagui';
import { Switch } from 'tamagui';
import styles from '@stylesheet';
import { ValidationType } from '../types/validatorTypes';
import updateStoreHandler from '../utils/updateStoreHandler';
import ComponentRenderer from './ComponentRenderer';
import { Button, H5, YStack } from 'tamagui';
import { useMemo } from 'react';
import defaultValComponents, { ValidationComponentType } from '../utils/defaultValComponents';
// Define an array of configuration objects for each component
const validationComponents: ValidationComponentType[] = [
  ...defaultValComponents,
  { key: 'minValue', label: 'Min Value', type: 'textInput', inputMode: 'numeric' },
  { key: 'maxValue', label: 'Max Value', type: 'textInput', inputMode: 'numeric' },
  { key: 'default', label: 'Default Value', type: 'textInput', inputMode: 'numeric' },
  { key: 'step', label: 'Step', type: 'textInput', inputMode: 'numeric' },
  { key: 'customValues', label: 'Custom Values', type: 'boolean' }, // Custom values are separated by commas
  { key: 'customValueText', label: 'Custom Value Text', type: 'textInput' },
];

const SliderValidation = ({ item, index }: ValidationType) => {
  const initialObject = item || {};
  const initialMap = useMemo(() => new Map(Object.entries(initialObject)), [initialObject]);
  const [validationOptions, setValidationOptions] = useState(initialMap);
  const { key, label, type, inputMode } = validationComponents[5];
  const [textValue, setTextValue] = useState(validationOptions.get(key));
  const options = useMemo(() => validationOptions.get('enum') || [], [validationOptions]);

  const updateMap = (key, value) => {
    setValidationOptions((prevMap) => new Map(prevMap.set(key, value)));
  };

  const handleValidationChange = (value, key) => {
    updateMap(key, value);
    const options = { value, type: key };
    updateStoreHandler({ index, option: options });
  };

  const _handleAddOption = () => {
    if (textValue === '') return;
    const newOptions = [...options, textValue];
    handleValidationChange(newOptions, 'enum');
    setTextValue('');
  }

  const _handleRemoveOption = (optionToRemove) => {
    const newOptions = options.filter((option) => option !== optionToRemove);
    handleValidationChange(newOptions, 'enum');
  }



  return (
    <YStack style={[styles.validationView, { flexWrap: 'wrap' }]}>
      <View>
        <H5>Common Scales</H5>
        <FlatList
          data={[
            { label: 'Satisfied/Not Satisfied', values: ['Very Satisfied', 'Satisfied', 'Not Satisfied', 'Disappointed'], step: 1, minValue: 0, maxValue: 3 },
            { label: 'Agree/Disagree', values: ['Strongly Agree', 'Agree', 'Neutral', 'Disagree', 'Strongly Disagree'], step: 1, minValue: 0, maxValue: 4 },
            {label: '1 to 5', values: ['1', '2', '3', '4', '5'], step: 1, minValue: 1, maxValue: 5 },
            { label: 'Good/Not Good', values: ['Excellent', 'Great', 'Good', 'Not Good', 'Bad', 'Very Bad'], step: 1, minValue: 0, maxValue: 4 },
            { label: '1 to 10', values: Array.from({ length: 10 }, (_, i) => (i + 1).toString()), step: 1, minValue: 1, maxValue: 10 }
          ]}
          horizontal
          keyExtractor={(item) => item.label}
          contentContainerStyle={{ gap: 5 }}
          renderItem={({ item }) => (
            <Button
              onPress={() => {
                handleValidationChange(item.values, 'enum');
                setTimeout(() => handleValidationChange(item.step, 'step'), 50);
                handleValidationChange(item.minValue, 'minValue');
                handleValidationChange(item.maxValue, 'maxValue');
              }}
              style={{ margin: 5 }}
            >
              {item.label}
            </Button>
          )}
        />
      </View>
      {validationComponents.map((component) => component.key != 'customValueText' && (
        <View key={component.key} style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', position: 'relative', flexWrap: 'wrap' }}>
          {
            component.type === 'switch' &&
            <Text style={{ flex: 1 }}>{component.label}</Text>
          }
          <ComponentRenderer item={item} component={component} index={index} />
        </View>
      ))}
      {
        item?.customValues &&
        <View style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', position: 'relative', flexWrap: 'wrap' }}>
          <Text>Custom Values</Text>
          {
            //Find number of custom values and render text input for each
            options.map((option, index) => (
              <View key={index} style={{ flexDirection: 'row', alignItems: 'center', alignSelf: 'stretch', position: 'relative', flexWrap: 'wrap' }}>
                <Text>{index.toString()}</Text>
                <Text>{option}</Text>
                <Button onPress={() => _handleRemoveOption(option)}>Remove</Button>
              </View>
            ))
          }
          <TextInput
            style={styles.textInput}
            value={item.customValueText}
            onChangeText={(text) => updateStoreHandler(index, 'customValueText', text)}
          />
          </View>
      }
    </YStack>
  );
};

export default SliderValidation;
